<template>
	<div class="hello">
		<RobotSocket ref="robotSocket" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<Head type='admin' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>
		<audio :src="phoneMp3" loop ref="pnhoneAudio"></audio>

		<audio :src="didiMp3" @ended="changeMusic()" ref="eventAudio"></audio>
		<div class="header-box box-top" v-if="attack"></div>
		<div class="header-box box-left" v-if="attack"></div>
		<div class="header-box box-right" v-if="attack"></div>
		<div class="header-box box-bottom" v-if="attack"></div>

		<!-- 事件误识别 -->
		<el-dialog :visible.sync="ifWrong" width="30%" center :close-on-click-modal="false">
			<div class="warningDom">
				<img src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.MisidentificationReporting }}</div>
				</div>
				<div class="textarea">
					<div style="margin-bottom: .5vw;">{{ languageJson.BrieflyDescribe }}</div>
					<el-input type="textarea" :rows="3" :placeholder="languageJson.PleaseFillIn" maxlength="200" show-word-limit v-model="remark"></el-input>
				</div>
				<div class="btnDom">
					<div class="newBtn1" style="width: 25%;" @click="ifWrong = false">{{ languageJson.Cancel }}</div>
					<div class="newBtn1 newBtn1do" style="width: 25%;" @click="submitWrong()">{{ languageJson.Submit }}</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="ifWarning" width="30%" center :close-on-click-modal="false">
			<div class="warningDom">
				<img src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.OperationTips }}</div>
				</div>
				<!-- <img src="../../../static/imgV2/loding.png" alt=""> -->
				<div class="title">
					【{{ warningObj.robotName }}】{{ languageJson.policeCheck }}</div>
				<div class="btnDom">
					<div class="newBtn1 newBtn1do" style="width: 50%;" @click="toWarning()">{{ languageJson.checkNow }}</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="flvOpen" width="100%" center>
			<div style="position: fixed;width: 100%;height: 100%;left: 0%;top: 0%;background-color: black;">
				<i class="el-icon-close"
					style="position: absolute;right: 10px;top: 10px;cursor: pointer;font-size: 2vw;z-index: 99;color: white;"
					@click="flvOpen = false"></i>
				<RobotFlv :playStatus='true' :ststus='checkFlv.ststus'
					:rid='checkFlv.robotId' :rtmpSrc="(checkFlv.robotType == '01' || checkFlv.robotType == '06') ? checkFlv.rFront : checkFlv.flvPtz" />
			</div>
		</el-dialog>

		<el-dialog :visible.sync="ifVoice" width="30%" center :close-on-click-modal="false">
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;height: 100%;" src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.OperationTips }}</div>
				</div>
				<!-- <img style="width: 100%;height: 100%;" src="../../../static/imgV2/robotImg.png" alt=""> -->
				<div
					style="position: absolute;width: 100%;top: 35%;font-size: 1vw;color: white;font-weight: 600;text-align: center;">
					【{{ ifVoiceObj.robotName }}】{{ languageJson.Emergency }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<div class="newBtn1" style="width: 40%;" @click='closeVoice()'>{{ languageJson.hangup }}</div>
					<div class="newBtn1 newBtn1do" style="width: 40%;" @click='openVoice()'>{{ languageJson.answer }}</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="dialogVisible" width="30%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.OperationTips }}</div>
				</div>
				<!-- <img style="width: 100%;height: 100%;" src="../../../static/imgV2/robotImg.png" alt=""> -->
				<div
					style="position: absolute;width: 100%;top: 35%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">
					{{ languageJson.ExitText }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<div class="newBtn1" style="width: 40%;" @click="dialogVisible = false">{{ languageJson.Cancel }}</div>
					<div class="newBtn1 newBtn1do" style="width: 40%;" @click="getOut()">{{ languageJson.Exit }}</div>
				</div>
			</div>
		</el-dialog>

		<div class="groupDom">
			<img class="groupDom-left" v-if="groupList.length > 5" src="../../../static/imgV2/leftCheck.png"
				@mousedown="mapScroll('left')" alt="">
			<img class="groupDom-right" v-if="groupList.length > 5" src="../../../static/imgV2/rightCheck.png"
				@mousedown="mapScroll('right')" alt="">
			<div class="tapGroup">
				<div class="groupLi" v-for="(obj, $index) in groupList" :key="$index" @click="changeGroup($index)">
					<img :src="obj.check ? check0 : check1" alt="">
					<div class="groupLi-title">{{ obj.name }}</div>
				</div>
			</div>
		</div>

		<div class="divCenter">
			<div class="box">
				<div v-for="(item, index) in centerDIV" :class="changeRobotX2(item.number) ? 'box-item box-item-x2' :'box-item'" :key="index" @click="toDetail(item, false)">
					<div class="title">
						<div :class="changeRobotX2(item.number) ? 'name nameX2 min-box' : 'name min-box'">{{item.rName}}&nbsp; <span v-if="item.onlineStatus == '1'">{{item.ststusName}}</span> </div>
						<div :class="changeRobotX2(item.number) ? 'power powerX2' : 'power'" v-if="item.onlineStatus == '1'" :style="{'marginRight': item.power =='100' ? '1.8vw': '1.5vw'}">
							<div class="power-text">&nbsp;{{item.power}}%</div>
							<RobotPower class="power-icon" :number='item.power' :type='item.ststus'
								:state='item.robotType' />
						</div>
					</div>

					<div class="offline" v-if="item.onlineStatus == '2'">
						<div :class="changeRobotX2(item.number) ? 'label labelx2' : 'label'">{{ languageJson.Robotoffline }}</div>
					</div>

					<img v-if="item.number == ifVoiceObj.robotNumber" class="itemBackImg" :src="changeRobotX2(item.number) ? backImageRed2 : backImageRed1" alt="">
					<img v-else class="itemBackImg" :src="changeRobotX2(item.number) ? backImage2 : backImage1" alt="">

					<div class="video" v-if="item.onlineStatus == '1'">
						<RobotFlv playAudo="stop" :playStatus='item.playStatus' @playStop='playStop($event, index)'
							:vSocketData='vSocketData' :ststus='item.ststus' :rid='item.robotId'
							:rtmpSrc="(item.robotType == '01' || item.robotType == '06') ? item.rFront : item.flvPtz" />
					</div>
					<div class="footer" v-if="item.onlineStatus == '1'">
						<div class="l">
							<img :src="item.playStatus ? play0 : play1" @click.stop="flvPlay(item.playStatus, index)" />
							<img src="../../../static/imgV2/Refresh.png" @click.stop="flvPlay(false,index)" />
						</div>
						<div class="r">
							<img src="../../../static/imgV2/fullScreen-0.png" @click.stop="videoFull(item)">
							<div :class="changeRobotX2(item.number) ? 'btns btnsx2': 'btns'" @click.stop="videoX2(item)"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="importantEvent" v-if="rightUl.length > 0" @click="openDialog()">
			<div style="display: flex;align-items: center;">
				<img style="width: 0.6vw;margin-right: 0.2vw;" src="../../../static/imgV2/breathe.gif" alt="">
				<div>{{ languageJson.ImportantHandled }}（{{ rightUl.length }}）</div>
			</div>
			<img style="width: 1vw;height: 1vw;" src="../../../static/imgV2/newDialog-2.png" alt="">
		</div>

		<div v-if="eventDialog" style="position: fixed;width: 100%;height: 100%;background-color: rgba(0,0,0,0.8);z-index: 99;"></div>
		<div :class="eventDialog ? 'openEvent' : 'openEvent closeAEvent'">
			<div style="width: 79%;" ref="openDom">
				<EventFaceOpen v-if="openState == 'face'" @wrong="wrongFun('3', true)" type='user' :robotInfo="faceInfoOpen" @closeEventFace='closeOpenEvent()'></EventFaceOpen>
				<EventImgOpen v-if="openState == 'imgs'" @wrong="wrongFun('4', true)" type='user' :robotInfo="robotInfoEventOpen" @closeEventImage='closeOpenEvent()'></EventImgOpen>
			</div>
			<div style="width: 20%;">
				<div style="text-align: right;height: 3vw;">
					<img src="../../../static/imgV2/newDialog-3.png" style="width: 1.3vw;height: 1.3vw;cursor: pointer;margin: 0.6vw 0 0.4vw 0;" @click="eventDialog = false" alt="">
				</div>
				<div class="openEventDom" ref="scrollContainer">
					<div v-for="(obj, index) in rightUl" :key="index" class="eventListDom" @click="drawOpenEvent(obj, index)">
						 <div class="eventTitle">
							<div class="eventTitle-background"></div>
							<div class="eventTitleName">
								<span>{{ obj.eName }}</span>
								<span>{{ obj.date }} {{ obj.insDate }}</span>
							</div>
						 </div>
						<img :src="obj.imgUrl" :class="checkImg == index ? 'checkImgDomColor' : 'checkImgDom'" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getItem,
		setToken,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth'
	import {
		getGroup,
		saveRobotHistory,
		getVideoList,
		getRobotEventInfo,
		completionInfo,
		personType,
		getRobotEventList,
		alarmOperate,
		reportMisIdentification
	} from '@/api/admin'
	import {
		groupByDuty
	} from '@/api/user'
	import Head from '@/components/Head.vue'
	import RobotSocket from '@/components/RobotSocket.vue'
	import RobotFlv from '@/components/flv264V3.vue'
	import RobotPower from '@/components/RobotPower.vue'
	import EventFaceOpen from '@/page/robotDetail/components/eventFaceOpen.vue'
	import EventImgUser from '@/page/robotDetail/components/eventImgUser.vue'
	import EventImgOpen from '@/page/robotDetail/components/eventImgOpen.vue'

	export default {
		name: 'login',
		components: {
			Head,
			RobotSocket,
			RobotFlv,
			RobotPower,
			EventFaceOpen,
			EventImgUser,
			EventImgOpen
		},
		data() {
			return {
				evenType: '0',
				ifWrong: false,
				remark: '',
				ifWarningInterval: null,
				ifVoiceType: false,
        robotNumbers: "",
				warningObj: {
					robotId: "",
					robotName: "",
					robotNumber: ""
				},
				ifWarning: false,
				checkImg: 0,
				rightUl: [],
				openState: '',
				faceInfoOpen: {},
				robotInfoEventOpen: {},
				eventDialog: false,
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
        who: localStorage.getItem('userInfo'),
				check0: require('../../../static/imgV2/checkSelect-0.png'),
				check1: require('../../../static/imgV2/checkSelect-1.png'),
				play0: require('../../../static/imgV2/flvstop.png'),
				play1: require('../../../static/imgV2/flvplay.png'),
				phoneMp3: require('../../../static/audio/phone.mp3'),
				didiMp3: require('../../../static/audio/didi.mp3'),
				backImage1: require('../../../static/imgV2/robot-x1.png'),
				backImage2: require('../../../static/imgV2/robot-x2.png'),
				backImageRed1: require('../../../static/imgV2/robot-red-x1.png'),
				backImageRed2: require('../../../static/imgV2/robot-red-x2.png'),
				dialogClose: require('../../../static/img/close.png'),
				eventsList: [],
				nowTime: new Date().getTime(),
				tapType: false,
				dialogVisible: false,
				attack: false,
				groupList: [],
				centerDIV: [],
				vSocketData: {},
				ifVoice: false,
				ifVoiceObj: {
					useVoice: "",
					robotNumber: "",
					robotName: ""
				},
				flvOpen: false,
				checkFlv: {
					playStatus: true,
					ststus: "",
					robotId: "",
					robotType: "",
					rFront: "",
					flvPtz: ""
				},
				personTypeCode: [],
				idTypeCode: [{
					code: "1",
					name: "身份证"
				}],
				ifShowLeave: false
			}
		},
		updated() {
			let that = this
			let domList = document.getElementsByClassName('alert-check-user')
			for (var i = 0; i < domList.length; i++) {
				if (i < 4) {
					domList[i].style.top = (i * 4) + '%'
					domList[i].style.left = (i * 3) + '%'
				} else {
					domList[i].style.top = (4 * 4) + '%'
					domList[i].style.left = (4 * 3) + '%'
				}
			}
		},
		mounted() {
			let that = this
			that.getGroup()
			that.personType(getItem('tenantInfoId'))
		},
		methods: {
			wrongFun(type, state) {
				this.evenType = type
				this.ifWrong = state
			},
			submitWrong() {
				let that = this
				reportMisIdentification({
					eventId: that.robotInfoEventOpen.eventId,
					remark: that.remark
				}).then(res => {
					that.ifWrong = false
					that.remark = ''
					that.$notify({
						title: languageJson.SubmitSuccess,
						type: 'success'
					})
					if (that.evenType == '3') {
						that.faceInfoOpen.bace.isAddMisIdentification = true
					} else if (that.evenType == '4') {
						that.robotInfoEventOpen.isAddMisIdentification = true
					}
				})
			},
			// 丰台 警情立即处理
			toWarning() {
				let that = this
				alarmOperate({
					robotId: that.warningObj.robotId,
					robotNumber: that.warningObj.robotNumber,
					tenantInfoId: getItem('tenantInfoId'),
					status: '0'
				}).then(res => {
					that.$router.push({
						name: 'detail',
						query: {
							robotId: that.warningObj.robotId,
							type: 'user'
						}
					})
				})
			},
			closeOpenEvent() {
				let that = this
				that.$refs.scrollContainer.scrollTop = 0;
				if (that.rightUl.length > 1) {
					let groupAry = [];
					that.groupList.map(res => groupAry.push(res.groupingId))
					getRobotEventList(groupAry.toString(), getItem('tenantInfoId'), '1', '1').then(res => {
						that.checkImg = 0
						if (res && res.data.length > 0) {
							that.rightUl = res.data
							that.openState = that.rightUl[0].operationType == '3' ? 'face' : 'imgs'
							that.showRobot(that.rightUl[0], true)
						} else if (res.data.length == 0) {
							that.rightUl = []
							that.eventDialog = false
						}
					})
				} else {
					that.rightUl = []
					that.eventDialog = false
				}
			},
			openDialog() {
				this.eventDialog = true
				this.checkImg = 0
				this.$refs.scrollContainer.scrollTop = 0;
				if (this.rightUl.length > 0) {
					this.openState = this.rightUl[0].operationType == '3' ? 'face' : 'imgs'
					this.showRobot(this.rightUl[0], true)
				}
			},
			drawOpenEvent(obj, index) {
				this.checkImg = index
				this.openState = obj.operationType == '3' ? 'face' : 'imgs'
				this.showRobot(obj, true)
			},
			showRobot(vo, openType) {
				let that = this
				getRobotEventInfo(vo.eventId).then(res => {
          that.attack = false;
					if (res.data && res.data.imgList.length == 0) {
						that.$notify({
							title: languageJson.noImage,
							type: 'warning'
						})
					} else {
						that.robotInfoEventOpen = res.data
						if (res.data.operationType == '3') {
							that.getCompletionInfo(res.data, openType)
						} else {
							if (!openType) {
								that.ifShowRobot = true
							}
						}
					}
				})
			},
			getCompletionInfo(bace,openType) {
				let that = this
				completionInfo({
					faceDatebaceId: bace.faceDatabaceId
				}).then(resFace => {
					if (!openType) {
						that.ifShowFace = true
					}
					that.faceInfo = {
						bace,
						...resFace.data
					}
					that.faceInfo.similarity = (Number(bace.similarity) * 100).toFixed(2)
					that.faceInfo.registerPhotos = bace.registerPhotos
					that.faceInfo.snapPhotos = bace.snapPhotos
					if (resFace.data.idType) {
						that.faceInfo.idType = that.idTypeCode.find(rev => rev.code == resFace.data.idType).name
					} else {
						that.faceInfo.idType = '--'
					}
					if (resFace.data.personTypeId) {
						that.faceInfo.personTypeId = that.personTypeCode.find(rev => rev.personTypeId == resFace.data.personTypeId).typeName
					} else {
						that.faceInfo.personTypeId = '--'
					}
					that.faceInfoOpen = that.faceInfo
				})
			},
			personType(tId) {
				let that = this
				personType({
					tenantInfoId: tId
				}).then(res => {
					if (res) {
						that.personTypeCode = res.data
					}
				})
			},
			changeRobotX2(number) {
				if (getItem("robotx2")) {
					let getRobot = getItem("robotx2").split(',');
					return getRobot.includes(number);
				} else {
					return false
				}
			},
			closeEvent(index) {
				this.eventsList.splice(index, 1)
			},
			changeMusic() {
        console.log("账号账号账号")
        console.log(localStorage.getItem('userInfo'))
        console.log(getItem('userInfo').account)
        this.who = JSON.parse(localStorage.getItem('userInfo'))
        console.log(this.who.account)
        if (this.who.account != 'jbzstaff2' && this.who.account != 'jbzstaff1' && this.who.account != 'jbzstaff3' && this.who.account != 'jbzstaff2' && this.who.account != 'jrcsatff3'){
          this.attack = false
        }else{
          if (this.attack == true){
            this.$refs.eventAudio.play()
          }
        }
				// this.attack = false
			},
			playStop(type, index) {
				this.centerDIV[index].playStatus = (type == 'play') ? true : false
			},
			toDetail(data, playStatus) {
				let that = this
				if (data.onlineStatus == '1') {
					this.$router.push({
						name: 'detail',
						query: {
							robotId: data.robotId,
              robotNumbers:this.robotNumbers,
							type: 'user'
						},
						params: {
							ifPlay: playStatus,
							ifPType: that.ifVoiceType
						}
					})
				} else {
					this.$notify.error({
						title: languageJson.RobotNotOnline
					})
				}
			},
			robotX2(data) {
				this.checkFlv = data
				this.flvOpen = true
			},
			videoFull(data) {
				this.checkFlv = data
				this.flvOpen = true
			},
			videoX2(item) {
				if (getItem("robotx2")) {
					let getRobot = getItem("robotx2").split(',');
					if ( getRobot.includes(item.number) ) {
						getRobot.splice(getRobot.indexOf(item.number), 1)
						setItem("robotx2", getRobot.toString())
					} else {
						setItem("robotx2", (getItem("robotx2") + ',' + item.number))
					}
				} else {
					setItem("robotx2", item.number)
				}
				item.x2 = !item.x2;
				this.centerDIV = this.centerDIV.sort(this.order);
			},
			order(a, b) {
				if (a.x2 > b.x2) {
					return -1;
				} else if (a.x2 < b.x2) {
					return 1;
				} else {
					return 0;
				}
			},
			closeVoice() {
				let that = this
				that.$confirm(that.languageJson.ConfirmHangUp, that.languageJson.prompt, {
					confirmButtonText: that.languageJson.end,
					cancelButtonText: that.languageJson.Cancel,
					type: "warning",
				}).then(() => {
					that.ifVoice = false
					that.ifVoiceObj.useVoice = ""
					that.ifVoiceObj.robotNumber = ""
					that.ifVoiceObj.robotName = ""
				}).catch(() => {})
			},
			openVoice() {
				let that = this
				let findPlay = that.centerDIV.find(res => res.number == that.ifVoiceObj.robotNumber )
				that.toDetail(findPlay, true)
			},
			flvPlay(type, index) {
				this.centerDIV[index].playStatus = !type
				this.centerDIV = JSON.parse(JSON.stringify(this.centerDIV))
			},
			getVideoList(groups) {
				let that = this
				let checkGroupList = []
        let noList = [];
				groups.forEach(res => {
					if (res.check) checkGroupList.push(res.groupingId)
				})
				if (checkGroupList.length == 0) {
					that.centerDIV = []
				} else {
					getVideoList({
						groupingIds: checkGroupList.toString()
					}).then(res => {
						that.getRobotEventList()
						if (res && res.data) {
							that.centerDIV = res.data.map(item => {
                noList.push(item.number)
								return {
									...item,
									x2: that.changeRobotX2(item.number)
								}
							})
              this.robotNumbers = noList.join();
							that.centerDIV.map(res => {
								res.playStatus = false
							})
							that.centerDIV = JSON.parse(JSON.stringify(that.centerDIV));
							that.centerDIV = that.centerDIV.sort(that.order);
						} else {
							that.centerDIV = []
						}
					})
				}
			},
			changeGroup(index) {
				let that = this
				that.groupList[index].check = that.groupList[index].check ? false : true
				that.getVideoList(that.groupList)
			},
			mapScroll(type) {
				let leftData = document.getElementsByClassName('tapGroup')[0].scrollLeft
				if (type == 'left') {
					document.getElementsByClassName('tapGroup')[0].scrollLeft = leftData - 200
				} else {
					document.getElementsByClassName('tapGroup')[0].scrollLeft = leftData + 200
				}
			},
			getGroup() {
				let that = this
				groupByDuty({
					tenantInfoId: getItem('tenantInfoId')
				}).then(res => {
					if (res.data && res.data.dutyList.length > 0) {
						res.data.dutyList.forEach((res, index) => {
							that.groupList.push({
								...res,
								check: true
							})
						})
						that.getVideoList(that.groupList)
					} else {
						that.groupList = []
					}
				})
			},
			changeTap(data) {
				this.tapType = data
			},
			getRobotEventList() {
				let that = this
				let groupAry = [];
				that.groupList.map(res => groupAry.push(res.groupingId))
				getRobotEventList(groupAry.toString(), getItem('tenantInfoId'), '1', '1').then(res => {
					if (res && res.data.length > 0) {
						that.rightUl = res.data
					}
				})
			},
			doSocker(socketData) {
        console.log("socket 收到了收到了")
        console.log(socketData.socketType)
				let that = this
				that.vSocketData = socketData
				if (socketData.socketType == '1') {
					for (let i = 0; i < that.centerDIV.length; i++) {
						if (that.centerDIV[i].robotId == socketData.robotId) {
							that.centerDIV[i].ststusName = that.languageCheck == 'English' ? socketData.enStstusName : socketData.ststusName
							that.centerDIV[i].power = socketData.power
							that.centerDIV[i].ststus = socketData.ststus
						}
					}
					that.centerDIV = JSON.parse(JSON.stringify(that.centerDIV))
				} else if (socketData.socketType == '2') {
          console.log("收到了socket Type 2的事件")
          console.log(socketData.disShowFlg)
          console.log(socketData.results)
          console.log(that.role)
					// 新增事件
					if (that.centerDIV.length > 0) {
						if (socketData.disShowFlg == '1' && socketData.results != '5') {
							let checkVo = that.centerDIV.find(v => v.robotId == socketData.robotId)
							if (that.languageCheck == 'English') {
								checkVo.resultsName = checkVo.enResultsName
								checkVo.eventlnsDate = checkVo.enEventlnsDate
								checkVo.eName = checkVo.eEnName
							}
							if (checkVo) {
								that.getRobotEventList()
							}
						}
					}

          // 添加事件弹框
          if (socketData.disShowFlg == '1' && socketData.results != '5') {
            if (that.attack != true){
              that.$refs.eventAudio.play()
              that.attack = true
              setTimeout(() => {
                // that.attack = false
              }, 3000)
            }

          }
				} else if (socketData.socketType == '7') {
					for (let i = 0; i < that.centerDIV.length; i++) {
						if (that.centerDIV[i].robotId == socketData.robotId) {
							that.centerDIV[i].onlineStatus = socketData.onlineStatus
						}
					}
				} else if (socketData.socketType == '14') {
					for (let i = 0; i < that.centerDIV.length; i++) {
						if (that.centerDIV[i].robotId == socketData.robotId) {
							if (socketData.status == '2' && that.centerDIV[i].onlineStatus == '2') {
								that.centerDIV[i].onlineStatus_name = '1'
							}
						}
					}
				} else if (socketData.socketType == '17') {
					if (socketData.status == '0') {
						that.ifVoiceType = false
						that.ifVoice = true
						that.ifVoiceObj.useVoice = socketData.useVoice
						that.ifVoiceObj.robotNumber = socketData.robotNumber
						that.ifVoiceObj.robotName = socketData.robotName
					}
				} else if (socketData.socketType == '23') {
					if (socketData.status == '0') {
						that.ifVoiceType = true
						that.ifVoice = true
						that.ifVoiceObj.useVoice = socketData.useVoice
						that.ifVoiceObj.robotNumber = socketData.robotNumber
						that.ifVoiceObj.robotName = socketData.robotName
					}
				} else if (socketData.socketType == '24') {
					if (socketData.status == '0') {
						that.warningObj = socketData
						that.ifWarning = true
					} else if (socketData.status == '2') {
						if (that.ifWarning && (that.warningObj.robotId == socketData.robotId)) {
							that.ifWarning = false
						}
					}
				}
				that.centerDIV = JSON.parse(JSON.stringify(that.centerDIV))
			},
			headOut(data) {
				this.dialogVisible = true
			},
			getOut() {
				removeToken()
				removeItem('differtime')
				removeItem('loginSuccess')
				this.dialogVisible = false
				this.$router.push({
					name: 'login'
				})
			}
		},
		watch: {
			ifWarning: {
				deep: true,
				handler(val, oldVal) {
					let that = this
					if (val) {
						that.ifWarningInterval = setTimeout(() => {
							that.ifWarning = false
						}, 30000)
					} else {
						if (that.ifWarningInterval) {
							clearTimeout(that.ifWarningInterval)
							that.ifWarningInterval = null
						}
					}
				}
			},
			eventsList: {
				deep: true,
				handler(val, oldVal) {
					if (val.length == 0) {
						this.attack = false
					}
				}
			},
			ifVoice: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$refs.pnhoneAudio.play()
						setTimeout(() => {
							that.ifVoice = false
							that.ifVoiceObj = {
								useVoice: "",
								robotNumber: "",
								robotName: ""
							}
						}, 60000)
					} else {
						that.$nextTick(() => {
							if (that.$refs.pnhoneAudio) that.$refs.pnhoneAudio.pause()
						})
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "./user.less";
</style>



// WEBPACK FOOTER //
// src/page/user/index.vue